import { useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import Web3WalletModal from './Web3WalletModal';
import { createAppKit, modal, useAppKitState } from '@reown/appkit/react';
import { Ethers5Adapter } from '@reown/appkit-adapter-ethers5';
import ThemeContext from 'components/context/ThemeContext';
import getBlockExplorerNameByUrl from '../../util/getBlockExplorerNameByUrl';
import VirtuSwapService from '../../util/web3Service';
import cachedChains from '../../constants/chains.json';

//Create modal
// 1. Get projectId
const projectId = process.env.REACT_APP_NEXT_PUBLIC_PROJECT_ID;
// 2. Set metadata
const metadata = {
    name: 'VirtuSwap',
    description: 'VirtuSwap',
    url: 'https://app.virtuswap.io/',
    icons: ['https://app.virtuswap.io/favicon.svg?v=2'],
};

const createAppKitChain = (chain) => ({
    id: chain.id,
    name: chain.name,
    chainNamespace: 'eip155',
    caipNetworkId: `eip155:${chain.id}`,
    network: chain.name?.replace(' ', '_')?.toLowerCase(),
    nativeCurrency: {
        name: chain.native_currency,
        symbol: chain.native_currency,
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: [chain.rpc_url],
        },
    },
    blockExplorers: {
        default: {
            name: getBlockExplorerNameByUrl(chain.block_explorer_url),
            url: chain.block_explorer_url,
        },
    },
    contracts: {
        multicall3: {
            address: VirtuSwapService.multicall3Address,
        },
    },
});

const createThemeVariables = (themeMode='dark') => ({
    '--w3m-color-mix': themeMode === 'dark' ? '#24292f' : '#f4f4f5',
    '--w3m-color-mix-strength': 20,
    '--w3m-z-index': 999999,
    '--w3m-border-radius-master': '3px',
});

const createWeb3ModalOptionsFromChains = (chains, themeMode='dark') => ({
    adapters: [new Ethers5Adapter()],
    metadata,
    networks: chains.map(createAppKitChain),
    chainImages: Object.fromEntries(chains.map(chain => [chain.id, chain.icon])),
    projectId,
    themeMode,
    themeVariables: createThemeVariables(themeMode),
    termsConditionsUrl: 'https://virtuswap.io/docs/tos.pdf',
    privacyPolicyUrl: 'https://virtuswap.io/docs/privacy.pdf',
    features: {
        swaps: false,
    },
});

// 3. Create the AppKit instance
createAppKit(createWeb3ModalOptionsFromChains(
    cachedChains || [],
    localStorage.getItem('VirtuSwapTheme') === 'light' ? 'light' : 'dark',
    ),
);


const WalletConnector = () => {
    const { open } = useAppKitState();
    const { theme } = useContext(ThemeContext);
    const {
        ChainList,
    } = useSelector((state) => state.Trade);

    useEffect(() => {
        modal.extendCaipNetworks(
            createWeb3ModalOptionsFromChains(
                ChainList.sort(({ vrouter_address: a }, { vrouter_address: b }) =>
                    (a===null)-(b===null) || -(a>b)||+(a<b) // inspired by https://stackoverflow.com/questions/29829205/sort-an-array-so-that-null-values-always-come-last
                )
            )
        );
    }, [ChainList]);

    useEffect(() => {
        modal.setThemeMode(theme);
        modal.setThemeVariables(createThemeVariables(theme));
    }, [theme]);

    return (
        <Web3WalletModal isOpen={open} />
    );
};
export default WalletConnector;

export { modal };
